import * as angular from 'angular';
import * as _ from 'lodash';
import {FolderTypeCodes} from "@common/model/documentFolder";
import {SubjectService} from "@common/service/subject.service";

// Directive Controller
class EcvDocumentFolder {
    item: any;
    folderModule: string;
    folderOperation: Function;
    folderTypeText: string;
    typeCodes;
    ldIncludes;
    team;

    static $inject = ["SubjectService"];

    constructor(private $sub: SubjectService) {
        this.typeCodes = eCareVault.FolderTypeCodes;
        this.ldIncludes = _.includes;
    }

    init = () => {
        switch (this.item.folderType) {
            case FolderTypeCodes.ENTERPRISE:
            case FolderTypeCodes.ENTERPRISE_TEAMS:
            case FolderTypeCodes.SYSTEM:
                this.folderTypeText = "System Folder";
                break;
            case FolderTypeCodes.RESOURCE_LIBRARY:
            case FolderTypeCodes.RESOURCE_LIBRARY_CHILD:
                this.folderTypeText = "Enterprise folder";
                break;
            case FolderTypeCodes.SYSTEM_SUBJECT:
            case FolderTypeCodes.SUBJECT:
                this.folderTypeText = "Team Folder";
                break;
            case FolderTypeCodes.PERSONAL:
                this.folderTypeText = "Personal Folder";
                break;
            case FolderTypeCodes.SHORT_CUT:
                this.folderTypeText = "Team Folder Shortcut";
                break;
            default:
                this.folderTypeText = "";
                break;
        }
        if (_.includes([FolderTypeCodes.SYSTEM_SUBJECT, FolderTypeCodes.SHORT_CUT], this.item.folderType)) {
            this.team = this.item.subject;
        }
    }

}

function documentFolder(): ng.IDirective {
    return {
        restrict: 'E',
        scope: true,
        templateUrl: 'app/common/itemBoard/components/itemFolder/document-folder.directive.html',
        replace: true,
        controller: EcvDocumentFolder,
        controllerAs: 'folderVm',
        bindToController: {
            'item': '=',
            'listView': '=',
            'folderModule': '@',
            'folderOperation': '=',
            'cmenuPlacement': '=',
            'cmenuSelector': '=?'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: EcvDocumentFolder): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.itemBoard').directive('ecvDocumentFolder', documentFolder);
